import { formatNumber, squareMetersToHectares } from "@/utils/helper";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/sharp-solid-svg-icons";
import React from "react";

interface AreaDetailProps {
  label: string;
  value: number;
  info?: string;
  useHectares?: boolean;
}

const AreaDetail: React.FC<AreaDetailProps> = ({
  label,
  value,
  info,
  useHectares,
}) => {
  return (
    <div className="flex justify-between">
      <div className="flex items-center gap-1 homepage-text-sm ">
        <span>{label}</span>
        {info && (
          <FontAwesomeIcon
            className="size-3.5 text-gray-400"
            icon={faCircleInfo}
          />
        )}
      </div>
      <div className="homepage-text-sm ">
        <p>
          {getValue(value, useHectares)} {getUnit(useHectares)}
        </p>
      </div>
    </div>
  );
};

function getValue(value: number, useHectares?: boolean) {
  if (useHectares) {
    return squareMetersToHectares(value);
  }
  return formatNumber(value);
}

function getUnit(useHectares?: boolean) {
  if (useHectares) {
    return <span>ha</span>;
  }
  return (
    <span>
      m<sup>2</sup>
    </span>
  );
}

export default AreaDetail;
